// extracted by mini-css-extract-plugin
export default {"EventCountdown":"EventCountdown_EventCountdown__vvmUw","icon":"EventCountdown_icon__YESZy","scrollBackground":"EventCountdown_scrollBackground__M5+zx"};